// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Minimal Profile Cards Design */
.view-employees-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  position: relative;
  padding: 0;
  margin: 0;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

/* Profile Card Wrapper for positioning */
.profile-card-wrapper {
  position: relative;
  margin-top: 40px; /* Space for half-overlapping avatar */
}

/* Profile Avatar Overlapping Effect */
.profile-avatar {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.profile-card-wrapper:hover .profile-avatar {
  transform: translateX(-50%) scale(1.1) !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2) !important;
}

/* Profile Card Styling */
.profile-card {
  position: relative;
  overflow: visible !important;
}

/* Post Badge Styling */
.post-badge {
  animation: slideInFromRight 0.6s ease-out;
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-card-wrapper {
    margin-top: 30px;
  }

  .profile-avatar {
    width: 70px !important;
    height: 70px !important;
    top: -35px !important;
    font-size: 1.5rem !important;
  }
}

@media (max-width: 480px) {
  .view-employees-container .MuiContainer-root {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .profile-card-wrapper {
    margin-top: 25px;
  }

  .profile-avatar {
    width: 60px !important;
    height: 60px !important;
    top: -30px !important;
    font-size: 1.25rem !important;
  }
}

/* Loading and Error States */
.view-employees-container .MuiCircularProgress-root {
  color: #667eea !important;
}

.view-employees-container .MuiAlert-root {
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

/* Grid Spacing Optimization */
.view-employees-container .MuiGrid-container {
  margin-top: 0 !important;
}

.view-employees-container .MuiGrid-item {
  padding-top: 0 !important;
}

/* Card Hover Animation Enhancement */
.profile-card {
  cursor: pointer;
}

.profile-card-wrapper:hover .profile-card {
  border-color: #667eea !important;
}

/* Typography Refinements */
.view-employees-container .MuiTypography-h6 {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  letter-spacing: -0.025em !important;
}

.view-employees-container .MuiTypography-body2 {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  letter-spacing: -0.01em !important;
}

/* Visual Hierarchy Enhancement */
.profile-card .MuiBox-root {
  position: relative;
}

/* Focus and Accessibility */
.profile-card:focus-within {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

/* Animation for cards appearing */
.profile-card-wrapper {
  animation: fadeInUp 0.6s ease-out forwards;
  opacity: 0;
  transform: translateY(20px);
}

.profile-card-wrapper:nth-child(1) {
  animation-delay: 0.1s;
}
.profile-card-wrapper:nth-child(2) {
  animation-delay: 0.2s;
}
.profile-card-wrapper:nth-child(3) {
  animation-delay: 0.3s;
}
.profile-card-wrapper:nth-child(4) {
  animation-delay: 0.4s;
}
.profile-card-wrapper:nth-child(5) {
  animation-delay: 0.5s;
}
.profile-card-wrapper:nth-child(6) {
  animation-delay: 0.6s;
}
.profile-card-wrapper:nth-child(7) {
  animation-delay: 0.7s;
}
.profile-card-wrapper:nth-child(8) {
  animation-delay: 0.8s;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(102, 126, 234, 0.2);
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1.5rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-content h2 {
  color: #1a1a1a;
  margin: 0 0 1rem;
  font-size: 1.8rem;
  font-weight: 600;
}

.loading-content p,
.error-content p {
  color: #6b7280;
  margin: 0;
  font-size: 1rem;
}

.error-content {
  border: 2px solid rgba(239, 68, 68, 0.2);
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.error-content h3 {
  color: #dc2626;
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: 600;
}

/* Header Section */
.header-section {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 3rem;
  margin-bottom: 3rem;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
}

.main-title {
  font-size: 3.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 1rem;
  line-height: 1.2;
}

.main-subtitle {
  font-size: 1.25rem;
  color: #6b7280;
  margin: 0 0 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
  font-weight: 400;
}

.team-stats {
  margin-top: 2rem;
}

.stat-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  display: inline-block;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.stat-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
}

/* Employee Cards Grid */
.employees-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.employee-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.employee-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.employee-card:hover .employee-avatar .avatar-placeholder,
.employee-card:hover .employee-avatar img {
  transform: scale(1.1);
}

.department-bar {
  height: 6px;
  background: linear-gradient(90deg, var(--dept-color), var(--dept-color-light));
}

.card-content {
  padding: 2rem;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

/* Avatar Section */
.employee-avatar {
  text-align: center;
  margin-bottom: 1.5rem;
}

.employee-avatar img,
.avatar-placeholder {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.employee-avatar img {
  object-fit: cover;
  border: 4px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.5rem;
  font-weight: 600;
  margin: 0 auto;
  text-transform: uppercase;
  border: 4px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

/* Employee Info */
.employee-info {
  text-align: center;
  margin-bottom: 1.5rem;
}

.employee-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.5rem;
  line-height: 1.2;
}

.employee-position {
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
}

.divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.1), transparent);
  margin: 1.5rem 0;
}

/* Employee Details */
.employee-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.detail-icon {
  font-size: 1.2rem;
  width: 20px;
  text-align: center;
}

.detail-text {
  color: #4b5563;
  font-size: 0.9rem;
  font-weight: 500;
}

.department-chip-container {
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: 1rem;
}

.department-chip {
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid;
  transition: all 0.2s ease;
  cursor: pointer;
}

.department-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Stats Footer */
.stats-footer {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
}

.stat-item {
  text-align: center;
  padding: 1rem;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 0.5rem;
  line-height: 1;
}

.stat-label {
  color: #6b7280;
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.8s ease-out forwards;
}

.fade-in-up {
  opacity: 0;
  animation: fadeInUp 0.8s ease-out forwards;
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 2rem 1rem;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .main-subtitle {
    font-size: 1.1rem;
  }

  .employees-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .employee-card {
    min-height: 350px;
  }

  .card-content {
    padding: 1.5rem;
  }

  .employee-avatar img,
  .avatar-placeholder {
    width: 80px;
    height: 80px;
  }

  .avatar-placeholder {
    font-size: 2rem;
  }

  .employee-name {
    font-size: 1.3rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .stat-number {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .header-section {
    padding: 2rem 1.5rem;
  }

  .main-title {
    font-size: 2rem;
  }

  .main-subtitle {
    font-size: 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .employee-card {
    min-height: 320px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .stats-footer {
    padding: 1.5rem;
  }
}

/* Custom Scrollbar */
.view-employees-container::-webkit-scrollbar {
  width: 8px;
}

.view-employees-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.view-employees-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.view-employees-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/components/ViewEmployees/ViewEmployees.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,+EAA+E;AACjF;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA,sCAAsC;AACtC;EACE,4DAA4D;AAC9D;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;AACvD;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,0FAA0F;EAC1F,mCAAmC;AACrC;;AAEA;EACE,0FAA0F;EAC1F,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,0CAA0C;EAC1C,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yCAAyC;EACzC,iDAAiD;EACjD,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,0CAA0C;EAC1C,yCAAyC;EACzC,6DAA6D;AAC/D;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Modern Minimal Profile Cards Design */\n.view-employees-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);\n  position: relative;\n  padding: 0;\n  margin: 0;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n/* Profile Card Wrapper for positioning */\n.profile-card-wrapper {\n  position: relative;\n  margin-top: 40px; /* Space for half-overlapping avatar */\n}\n\n/* Profile Avatar Overlapping Effect */\n.profile-avatar {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.profile-card-wrapper:hover .profile-avatar {\n  transform: translateX(-50%) scale(1.1) !important;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2) !important;\n}\n\n/* Profile Card Styling */\n.profile-card {\n  position: relative;\n  overflow: visible !important;\n}\n\n/* Post Badge Styling */\n.post-badge {\n  animation: slideInFromRight 0.6s ease-out;\n}\n\n@keyframes slideInFromRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profile-card-wrapper {\n    margin-top: 30px;\n  }\n\n  .profile-avatar {\n    width: 70px !important;\n    height: 70px !important;\n    top: -35px !important;\n    font-size: 1.5rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .view-employees-container .MuiContainer-root {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .profile-card-wrapper {\n    margin-top: 25px;\n  }\n\n  .profile-avatar {\n    width: 60px !important;\n    height: 60px !important;\n    top: -30px !important;\n    font-size: 1.25rem !important;\n  }\n}\n\n/* Loading and Error States */\n.view-employees-container .MuiCircularProgress-root {\n  color: #667eea !important;\n}\n\n.view-employees-container .MuiAlert-root {\n  border-radius: 12px !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;\n}\n\n/* Grid Spacing Optimization */\n.view-employees-container .MuiGrid-container {\n  margin-top: 0 !important;\n}\n\n.view-employees-container .MuiGrid-item {\n  padding-top: 0 !important;\n}\n\n/* Card Hover Animation Enhancement */\n.profile-card {\n  cursor: pointer;\n}\n\n.profile-card-wrapper:hover .profile-card {\n  border-color: #667eea !important;\n}\n\n/* Typography Refinements */\n.view-employees-container .MuiTypography-h6 {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif !important;\n  letter-spacing: -0.025em !important;\n}\n\n.view-employees-container .MuiTypography-body2 {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif !important;\n  letter-spacing: -0.01em !important;\n}\n\n/* Visual Hierarchy Enhancement */\n.profile-card .MuiBox-root {\n  position: relative;\n}\n\n/* Focus and Accessibility */\n.profile-card:focus-within {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n/* Animation for cards appearing */\n.profile-card-wrapper {\n  animation: fadeInUp 0.6s ease-out forwards;\n  opacity: 0;\n  transform: translateY(20px);\n}\n\n.profile-card-wrapper:nth-child(1) {\n  animation-delay: 0.1s;\n}\n.profile-card-wrapper:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.profile-card-wrapper:nth-child(3) {\n  animation-delay: 0.3s;\n}\n.profile-card-wrapper:nth-child(4) {\n  animation-delay: 0.4s;\n}\n.profile-card-wrapper:nth-child(5) {\n  animation-delay: 0.5s;\n}\n.profile-card-wrapper:nth-child(6) {\n  animation-delay: 0.6s;\n}\n.profile-card-wrapper:nth-child(7) {\n  animation-delay: 0.7s;\n}\n.profile-card-wrapper:nth-child(8) {\n  animation-delay: 0.8s;\n}\n\n@keyframes fadeInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid rgba(102, 126, 234, 0.2);\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1.5rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-content h2 {\n  color: #1a1a1a;\n  margin: 0 0 1rem;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.loading-content p,\n.error-content p {\n  color: #6b7280;\n  margin: 0;\n  font-size: 1rem;\n}\n\n.error-content {\n  border: 2px solid rgba(239, 68, 68, 0.2);\n}\n\n.error-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.error-content h3 {\n  color: #dc2626;\n  margin: 0 0 1rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n/* Header Section */\n.header-section {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 3rem;\n  margin-bottom: 3rem;\n  text-align: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);\n}\n\n.main-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 0 0 1rem;\n  line-height: 1.2;\n}\n\n.main-subtitle {\n  font-size: 1.25rem;\n  color: #6b7280;\n  margin: 0 0 2rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.6;\n  font-weight: 400;\n}\n\n.team-stats {\n  margin-top: 2rem;\n}\n\n.stat-badge {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 1rem;\n  display: inline-block;\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);\n  transition: all 0.3s ease;\n}\n\n.stat-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);\n}\n\n/* Employee Cards Grid */\n.employees-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 2rem;\n  margin-bottom: 3rem;\n}\n\n.employee-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n}\n\n.employee-card:hover {\n  transform: translateY(-12px) scale(1.02);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.employee-card:hover .employee-avatar .avatar-placeholder,\n.employee-card:hover .employee-avatar img {\n  transform: scale(1.1);\n}\n\n.department-bar {\n  height: 6px;\n  background: linear-gradient(90deg, var(--dept-color), var(--dept-color-light));\n}\n\n.card-content {\n  padding: 2rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Avatar Section */\n.employee-avatar {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.employee-avatar img,\n.avatar-placeholder {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.employee-avatar img {\n  object-fit: cover;\n  border: 4px solid rgba(255, 255, 255, 0.8);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.avatar-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 2.5rem;\n  font-weight: 600;\n  margin: 0 auto;\n  text-transform: uppercase;\n  border: 4px solid rgba(255, 255, 255, 0.8);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n}\n\n/* Employee Info */\n.employee-info {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.employee-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0 0 0.5rem;\n  line-height: 1.2;\n}\n\n.employee-position {\n  font-size: 1rem;\n  color: #6b7280;\n  margin: 0;\n  font-weight: 500;\n}\n\n.divider {\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.1), transparent);\n  margin: 1.5rem 0;\n}\n\n/* Employee Details */\n.employee-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.detail-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.detail-icon {\n  font-size: 1.2rem;\n  width: 20px;\n  text-align: center;\n}\n\n.detail-text {\n  color: #4b5563;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.department-chip-container {\n  display: flex;\n  justify-content: center;\n  margin-top: auto;\n  padding-top: 1rem;\n}\n\n.department-chip {\n  padding: 0.5rem 1rem;\n  border-radius: 50px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  border: 1px solid;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.department-chip:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Stats Footer */\n.stats-footer {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 2.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n}\n\n.stat-item {\n  text-align: center;\n  padding: 1rem;\n}\n\n.stat-number {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #667eea;\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.stat-label {\n  color: #6b7280;\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.8s ease-out forwards;\n}\n\n.fade-in-up {\n  opacity: 0;\n  animation: fadeInUp 0.8s ease-out forwards;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 2rem 1rem;\n  }\n\n  .main-title {\n    font-size: 2.5rem;\n  }\n\n  .main-subtitle {\n    font-size: 1.1rem;\n  }\n\n  .employees-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .employee-card {\n    min-height: 350px;\n  }\n\n  .card-content {\n    padding: 1.5rem;\n  }\n\n  .employee-avatar img,\n  .avatar-placeholder {\n    width: 80px;\n    height: 80px;\n  }\n\n  .avatar-placeholder {\n    font-size: 2rem;\n  }\n\n  .employee-name {\n    font-size: 1.3rem;\n  }\n\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n  }\n\n  .stat-number {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-section {\n    padding: 2rem 1.5rem;\n  }\n\n  .main-title {\n    font-size: 2rem;\n  }\n\n  .main-subtitle {\n    font-size: 1rem;\n  }\n\n  .card-content {\n    padding: 1rem;\n  }\n\n  .employee-card {\n    min-height: 320px;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .stats-footer {\n    padding: 1.5rem;\n  }\n}\n\n/* Custom Scrollbar */\n.view-employees-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.view-employees-container::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.view-employees-container::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n}\n\n.view-employees-container::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
